const VAR_MARKUP = /(\{\{([^{]+)\}\})/;

const resolveMarkups = (text: string, object: Record<string, unknown>) =>
  text.replace(new RegExp(VAR_MARKUP, 'g'), (_, p1, key) => `${object[`${key}`] || p1}`);

export default resolveMarkups;
